import { CarObject } from '../types'


// create copy object car and change current key
export function changeCarObj(obj: CarObject ): CarObject{
    const copyObj = {...obj };
    copyObj.name =  obj.name.replace(/left/g, 'right');
        
    return copyObj;
}


export function getPartnerId(){
    const search = window.location.search;

    return search.split('=')[1]
}

export function createName(type:string, long_name:string, fileName:string ):string {

    return `${type}__${long_name}__${fileName}`;
}


export function deleteAllSpaces(str: string): string{
    return  str.split('').map((s:string)=>{
        if(s!==" ")return s; 
        }).filter((s:string)=>{
        if(s)return true;
        return false
        }).join('') 
}